// Port of api/fuel/app/classes/model/user.php
import Model from 'offline/stream/model/base'
import F from 'offline/filter/constants'

export default Model.extend({
	table: 'user',
	prefix: 'user',
	key: 'user_id',
	fields: {
		user_id: Model.SCHEMA_KEY,
		user_status: Model.SCHEMA_NUMBER,
		user_syncing: Model.SCHEMA_NUMBER,
		user_upgrade: Model.SCHEMA_NUMBER,
		user_name: Model.SCHEMA_TEXT,
		user_password: Model.SCHEMA_TEXT,
		user_source: Model.SCHEMA_NUMBER,
		user_date_created: Model.SCHEMA_DATE_CREATE,
		user_date_registered: Model.SCHEMA_DATE,
		user_date_bgg: Model.SCHEMA_DATE,
		user_date_sync: Model.SCHEMA_DATE,
		user_date_login: Model.SCHEMA_DATE,
		user_date_upgrade: Model.SCHEMA_DATE,
		user_date_play_first: Model.SCHEMA_DATE,
		user_date_sync_first: Model.SCHEMA_DATE,
		user_date_sync_deep: Model.SCHEMA_DATE,
		user_date_sync_standard: Model.SCHEMA_DATE,
		user_date_sync_full: Model.SCHEMA_DATE,
		user_date_sync_added: Model.SCHEMA_DATE,
		user_date_notifications: Model.SCHEMA_DATE,
		user_date_patreon: Model.SCHEMA_NUMBER,
		user_date_avatar: Model.SCHEMA_DATE,
		user_firstname: Model.SCHEMA_TEXT,
		user_lastname: Model.SCHEMA_TEXT,
		user_sortname: Model.SCHEMA_TEXT,
		user_country: Model.SCHEMA_NUMBER,
		user_avatar: Model.SCHEMA_TEXT,
		user_patreon: Model.SCHEMA_TEXT,
		user_count_collection: Model.SCHEMA_NUMBER,
		user_count_collection_games: Model.SCHEMA_NUMBER,
		user_count_collection_expansions: Model.SCHEMA_NUMBER,
		user_count_ratings: Model.SCHEMA_NUMBER,
		user_count_plays: Model.SCHEMA_NUMBER,
		user_count_plays_games: Model.SCHEMA_NUMBER,
		user_count_lists: Model.SCHEMA_NUMBER,
		user_count_groups: Model.SCHEMA_NUMBER,
		user_count_buddies: Model.SCHEMA_NUMBER,
		user_count_hindex_added: Model.SCHEMA_NUMBER,
		user_verification_key: Model.SCHEMA_TEXT,
		user_hindex: Model.SCHEMA_NUMBER,
		user_sync_type: Model.SCHEMA_NUMBER,
		user_sync_day: Model.SCHEMA_NUMBER,
		user_sync_time: Model.SCHEMA_NUMBER,
		user_sync_zone: Model.SCHEMA_TEXT,
		user_data_queue: Model.SCHEMA_NUMBER,
		user_data_version: Model.SCHEMA_NUMBER,
		user_perks: Model.SCHEMA_JSON
	},
	methods: {
		get_type_constant: function() { return F.OWNER_USER },
		get_threshold: function() { return 1 },
		has_synchronised: function() { return this.get_date_sync() },
		is_registered: function() { return this.get_status() === 1 },
		is_upgraded: function() { return this.get_upgrade() > 0 },
		is_admin: function() { return false },
		get_date_next_sync: function() {
			var lastSync = this.get_date_sync() || 0
			if (!lastSync) return 0

			var date = new Date(lastSync * 1000)
			date.setHours(0, 0, 0, 0)

			if (this.get_upgrade()) {
				date.setDate(date.getDate() + 1)
				return Math.floor(date.getTime() / 1000)
			}

			var day = date.getDay()
			var diff = day === 0 ? 1 : 8 - day
			date.setDate(date.getDate() + diff)
			return Math.floor(date.getTime() / 1000)
		},
		get_slug: function() { return encodeURIComponent(this.get_name()).replace(/\+/g, ' ') },
		get_fullname: function() {
			var parts = []
			if (this.get_firstname()) parts.push(this.get_firstname())
			if (this.get_lastname()) parts.push(this.get_lastname())
			return parts.join(' ')
		},
		get_data_version: function() { return this._data.user_data_version || 0 },
		get_user_id: function() { return this.get_id() },
		to_array: function(shallow) {
			if (shallow) {
				return {
					id: this.get_id(),
					name: this.get_name(),
					fullname: this.get_fullname(),
					sortname: this.get_sortname(),
					country: this.get_country() || 0,
					slug: this.get_slug(),
					avatar: this.get_avatar()
				}
			}
			return {
				id: this.get_id(),
				name: this.get_name(),
				fullname: this.get_fullname(),
				sortname: this.get_sortname(),
				country: this.get_country() || 0,
				slug: this.get_slug(),
				avatar: this.get_avatar(),
				threshold: this.get_threshold(),
				early: [],
				config: {},
				hindex: {
					value: this.get_hindex(),
					limit: this.is_upgraded() ? 11 : 4,
					added: this.get_count_hindex_added() || 0,
					remaining: (this.is_upgraded() ? 11 : 4) - (this.get_count_hindex_added() || 0),
					tracking: []
				},
				date: {
					sync: this.get_date_sync() || 0,
					syncFirst: this.get_date_sync_first() || 0,
					registered: this.get_date_registered() || 0,
					firstPlay: this.get_date_play_first() || 0,
					nextSync: this.get_date_next_sync(),
					syncDeep: this.get_date_sync_deep() || 0,
					syncStandard: this.get_date_sync_standard() || this.get_date_sync() || 0,
					syncFull: this.get_date_sync_full() || 0
				},
				count: {
					collection: this.get_count_collection() || 0,
					ratings: this.get_count_ratings() || 0,
					plays: this.get_count_plays() || 0,
					lists: this.get_count_lists() || 0,
					groups: this.get_count_groups() || 0
				},
				requireSync: !this.has_synchronised(),
				queueSync: this.get_data_queue() || 0,
				syncType: this.get_sync_type() || 0,
				registered: this.get_status() || 0,
				upgraded: this.is_upgraded() ? 1 : 0,
				dailyperk: false,
				actions: [],
				subdomain: false,
				externaldomain: false,
				boosted: this.get_upgrade() >= 2,
				patreon: this.get_upgrade() >= 1 && this.get_date_patreon()
					? { year: parseInt(new Date(this.get_date_patreon() * 1000).getUTCFullYear(), 10) }
					: false
			}
		}
	}
})
